import DashboardProps from '../../models/dashboard-props.model'
import logoLink from '../images/WSRO-logo.png'

const LimitationPdf = require('../docs/Limitations.pdf');
const QuickGuide = require('../docs/Quick Guide.pdf');
const DisclaimerPdf = require('../docs/Disclaimers.pdf');

const getLink = (pdf: string, name: string) => {
  return `<a 
    href="${pdf}"
    color="secondary"
    target="_blank"
    rel="noopener noreferrer"
  >${name}</a>`
}

const WSRODashboardProps: DashboardProps= {
  navbar: {
    logoLink: logoLink,
    slogan: 'WSRO',
    logoAlt: 'WSRO Logo',
    ssoLoginText: 'Login with WSRO',
  },

  disclaimerProps: {
    showDisclaimer: false,
    onClick: (status: boolean) => {
      console.log('status', status)
    },
    data: {
      isDisclaimerOpened: false,
      disclaimerContent: {
        title: 'WSRO Disclaimer',
        logo: logoLink,
        welcomeText:
          'Thank you for visiting the Global Sugars Intake Dashboard. Before proceeding please read:',
        content: [
          `The ${getLink(LimitationPdf, 'Limitations of Sugars Intakes Data Document')}, which helps you to understand the <b>complexities and difficulties of estimating sugars intake and of comparing different geographical regions.</b>`,
          `The ${getLink(DisclaimerPdf, 'Terms and Conditions')}.`,
        ],
        buttonText: 'Accept',
        buttonLink: null,
      },
      supportDocuments: [
        {
          optionalId: '',
          isCheckbox: true,
          text: '',
          link: null,
          body: `Have read and understood, and accept the  ${getLink(DisclaimerPdf, 'Terms and Conditions') } of using this site and the associated ${getLink(DisclaimerPdf, 'Privacy & Terms Statement.')}.`,
        },
        {
          optionalId: '',
          isCheckbox: true,
          text: 'Limitations of Sugars Intakes Data Document',
          link: LimitationPdf,
          body: 'Have read and understood, and accept the  ',
        },
        {
          optionalId: 'receive-info',
          isCheckbox: true,
          body: 'Would like to receive information about our other products and services by email, in accordance with the ',
          link: DisclaimerPdf,
          text: 'Privacy & Terms Statement. You will always be able to cancel or amend your preferences.',
        }
      ],
      otherDocuments: [
        {
          body: `Before exploring the Global Sugars Intake Dashboard, it is highly recommended that you read the ${getLink(
            QuickGuide,
            'Quick Guide',
          )} to help you to understand how to use the tool.`,
          text: '',
          link: null,
        },
        {
          body:
            'To the best of Creme Global and WSRO’s knowledge, the information and data contained within the Global Sugars Intake Dashboard are accurate and up to date, as of <b>June 2023.</b>',
          text: '',
          link: null,
        },
        {
          body:
            'I understand Creme Global and WSRO are not responsible for any inaccuracies in the datasets and users are encouraged to check and use the original references and data sources when citing sugars intake data.',
          text: '',
          link: null,
        },
        {
          text: ' please get in touch.',
          body:
            "Our mission at WSRO is to provide evidence based scientific information and analysis to members and stakeholders on sugar's role in health and nutrition. If you plan to use the information provided in the Global Sugars Intake Dashboard within a publication or media broadcast and would like assistance in using the Dashboard and/or understanding the sugars intake data,",
          link: 'mailto:info@wsro.org',
        },
      ],
    },
  },
  keyCloak: {
    realm: 'qlik-qap',
    clientId: 'qlik-qap-kc-openid',
    url: 'https://login.cremeglobal.com/',
    credentials: {
      secret: 'eTbKEt3Q6zJ03NFuFfPr7UaaERyyd16S',
    },
    'enable-cors': true,
    'ssl-required': 'all',
    'confidential-port': 0,
    redirectUri: 'https://wsro.cremedatafoundry.com', // [ http://localhost:3000/ ,  https://wsro-dev.cremedatafoundry.com, https://wsro.cremedatafoundry.com ]
  },
}

export default WSRODashboardProps
